import React from 'react'
import { red } from '../../styles/material-ui-theme-v2'

// Error icon component
const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-label="Error"
    role="img"
    focusable="false"
    style={{
      display: 'inline-block',
      height: '12px',
      width: '12px',
      fill: red,
      marginRight: '4px',
      verticalAlign: 'middle',
    }}
  >
    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 10.2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm.8-6.6H7.2v5.2h1.6z"></path>
  </svg>
)

/**
 * ErrorMessage component
 *
 * A reusable component for displaying validation error messages with consistent styling.
 * Includes an error icon and formats text in the error color.
 *
 * @param {React.ReactNode} children - The error message content to display
 */
export const ErrorMessage = ({ children }: { children: React.ReactNode }) => (
  <div
    style={{
      color: red,
      fontSize: '0.75rem',
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: '8px',
    }}
  >
    <span style={{ flexShrink: 0 }}>
      <ErrorIcon />
    </span>
    <span style={{ marginTop: '1.5px' }}>{children}</span>
  </div>
)

export default ErrorMessage
